import { eCoSoActionTypeDefine } from "../../action-types/category/ICoSoActionType";
import { generateActions } from "../generateActions";

export const coSoActions = {
    ...generateActions(eCoSoActionTypeDefine, "CO_SO"),
   
}